import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_EMPLOYEE_REQUIRED_FUND_ACCOUNTS_API_ID =
  'DASHBOARD/EMPLOYEE_REQUIRED_FUND_ACCOUNTS_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_EMPLOYEE_REQUIRED_FUND_ACCOUNTS_API_ID,
  ({ id }) => ({
    endpoint: `/api/admin/employees/required-fund-accounts/${id}`,
    method: 'GET',
  })
);

export default apiCall;
